// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"ws_a zu_b zu_ry zu_pe zu_pf zu_ss","PanelFooter--link":"ws_b"};